export const SCRIPT_AI_HUB_CREDITS_EXHAUSTED_TOOLTIP =
  "Not enough AI credits for this action. Purchase a project license or add credits to continue.";

export const SCRIPT_AI_HUB_PIPELINE_RUNNING_TOOLTIP =
  "This pipeline is already running. Wait for it to finish before starting again.";

export const SCRIPT_AI_HUB_PIPELINE_BUSY_TOOLTIP =
  "Another AI run is in progress. Wait for it to finish before starting a new one.";

export const SCRIPT_AI_HUB_VERSION_SCRIPT_OFF_TOOLTIP =
  "Script breakdown is turned off for this script version.";

export const SCRIPT_AI_HUB_VERSION_CHARACTER_OFF_TOOLTIP =
  "Character breakdown is not enabled for this document.";

export const SCRIPT_AI_HUB_VERSION_COVERAGE_OFF_TOOLTIP =
  "Coverage is not enabled for this document.";

export type ScriptPipelineRowTooltipInput = {
  disabled: boolean;
  exhausted: boolean;
  isRerunning: boolean;
  isAnyPending: boolean;
  versionBlocked: boolean;
  versionBlockedMessage?: string;
};

export function getScriptPipelineRowTooltip(
  input: ScriptPipelineRowTooltipInput
): string | undefined {
  if (!input.disabled) {
    return undefined;
  }
  if (input.isRerunning) {
    return SCRIPT_AI_HUB_PIPELINE_RUNNING_TOOLTIP;
  }
  if (input.isAnyPending) {
    return SCRIPT_AI_HUB_PIPELINE_BUSY_TOOLTIP;
  }
  if (input.versionBlocked) {
    return input.versionBlockedMessage ?? SCRIPT_AI_HUB_VERSION_SCRIPT_OFF_TOOLTIP;
  }
  if (input.exhausted) {
    return SCRIPT_AI_HUB_CREDITS_EXHAUSTED_TOOLTIP;
  }
  return undefined;
}

export type RunBatchTooltipInput = {
  disabled: boolean;
  remaining: number;
  totalCost: number;
  scriptPipelinesBusy: boolean;
  canRunAll: boolean;
  unlimited?: boolean;
};

export function getRunBatchTooltip(input: RunBatchTooltipInput): string | undefined {
  if (!input.disabled) {
    return undefined;
  }
  if (input.scriptPipelinesBusy) {
    return SCRIPT_AI_HUB_PIPELINE_BUSY_TOOLTIP;
  }
  if (!input.unlimited && input.remaining < input.totalCost) {
    return `This batch needs ${input.totalCost} credits (${input.remaining} remaining). ${SCRIPT_AI_HUB_CREDITS_EXHAUSTED_TOOLTIP}`;
  }
  if (!input.canRunAll) {
    return SCRIPT_AI_HUB_CREDITS_EXHAUSTED_TOOLTIP;
  }
  return undefined;
}

export function canAffordScriptPipelineBatch(
  remaining: number,
  totalCost: number,
  unlimited = false
): boolean {
  if (unlimited) return true;
  return remaining >= totalCost;
}
